module.exports = __webpack_public_path__ + "img/mob-copied.db4d97f9.svg";